import { FC, useCallback, useMemo } from "react";
import { useHistory } from "react-router-dom";
import { CustomBgWrapper } from "shared/components/CustomBgWrapper/CustomBgWrapper";
import { ThemeProvider, useTheme } from "styled-components";
import { Container, GapContainer } from "./styles";
import { SlideNavigation } from "shared/components/slideNavigation";
import {
    allowedCampusTypeValues,
    getFrCampusTypeFromDomain,
    MAIN_CAMPUS_ID,
} from "./const";
import useQueryState from "shared/hooks/useQueryState";

const CampusExpert: FC<{ content: React.ReactNode, tagAdminFiltersContent: React.ReactNode }> = ({ content, tagAdminFiltersContent }) => {
    const theme = useTheme();
    const history = useHistory();
    const [{ campusType: campusId }] = useQueryState();
    const domainCampusType = getFrCampusTypeFromDomain();

    const tabs = useMemo(() => {
        return {};
    }, []);

    const onTabChange = useCallback((tab: string) => {
        if (tab === campusId) return;
        history.push(`/tag-expert?campusType=${tab}`);
    }, [campusId, history]);

    if (domainCampusType && campusId && campusId !== domainCampusType) {
        return <div>кампус не соответствует текущему домену</div>
    }

    if (campusId && !allowedCampusTypeValues.includes(campusId)) {
        return <div>Неверный идентификатор кампуса</div>
    }

    return (
        <ThemeProvider theme={theme}>
            <CustomBgWrapper backgroundColor={theme.app.backgroundColor}>
                <Container>
                    <GapContainer>
                        {tagAdminFiltersContent}
                        <SlideNavigation
                            activeIndexKey={campusId || domainCampusType || MAIN_CAMPUS_ID}
                            onChange={onTabChange}
                            items={tabs}
                            isLoading={false}
                        />
                    </GapContainer>
                    {content}
                </Container>
            </CustomBgWrapper>
        </ThemeProvider>
    )
}

export default CampusExpert;
import { FC, useCallback, useMemo } from "react";
import { useHistory } from "react-router-dom";
import { CustomBgWrapper } from "shared/components/CustomBgWrapper/CustomBgWrapper";
import { ThemeProvider, useTheme } from "styled-components";
import { Container, GapContainer } from "./styles";
import { SlideNavigation } from "shared/components/slideNavigation";
import {
    allowedCampusTypeValues,
    getFrCampusTypeFromDomain,
    MAIN_CAMPUS_ID,
} from "./const";
import useQueryState from "shared/hooks/useQueryState";

const CampusExpert: FC<{ content: React.ReactNode, tagAdminFiltersContent: React.ReactNode }> = ({ content, tagAdminFiltersContent }) => {
    const theme = useTheme();
    const history = useHistory();
    const [{ campusType: campusId }] = useQueryState();
    const domainCampusType = getFrCampusTypeFromDomain();

    const tabs = useMemo(() => {
        return {};
    }, []);

    const onTabChange = useCallback((tab: string) => {
        if (tab === campusId) return;
        history.push(`/tag-expert?campusType=${tab}`);
    }, [campusId, history]);

    if (domainCampusType && campusId && campusId !== domainCampusType) {
        return <div>кампус не соответствует текущему домену</div>
    }

    if (campusId && !allowedCampusTypeValues.includes(campusId)) {
        return <div>Неверный идентификатор кампуса</div>
    }

    return (
        <ThemeProvider theme={theme}>
            <CustomBgWrapper backgroundColor={theme.app.backgroundColor}>
                <Container>
                    <GapContainer>
                        {tagAdminFiltersContent}
                        <SlideNavigation
                            activeIndexKey={campusId || domainCampusType || MAIN_CAMPUS_ID}
                            onChange={onTabChange}
                            items={tabs}
                            isLoading={false}
                        />
                    </GapContainer>
                    {content}
                </Container>
            </CustomBgWrapper>
        </ThemeProvider>
    )
}

export default CampusExpert;
